<template>
    <div class="product-link">
        <h2 class="subtitle">Products in this bundle</h2>
        <div>
            <div v-if="bundledProducts.length < 1">
                This bundle does not have any products
                <br/>
            </div>
            <div v-for="product in bundledProducts">
                <router-link :to="{ name: 'product', params: {id: product.id}}">
                    {{ product.short_name }}
                </router-link>
                <a class="delete" @click="remove(product)"></a>
            </div>
        </div>
        <br/>
        <div v-if="!adding">
            <a class="button is-small" @click="adding = true">Add product to bundle...</a>
        </div>
        <div v-if="adding">
            <p class="control">
                <span class="select">
                    <select name="product-add" @change="add($event.target.value)">
                        <option>Select a product...</option>
                        <option v-for="product in availableProducts" :value="product.id">{{ product.short_name }} - {{ product.sku }}</option>
                    </select>
                </span>
                <button type="button" class="button" @click="adding = false">Cancel</button>
            </p>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    import {CREATE_PRODUCT_BUNDLE, DELETE_PRODUCT_BUNDLE} from "../../store/mutation-types"
    import sortAlphaNum from "../../utils/sortAlphaNum"
    export default {
        props: ['bundleId'],
        data() {
            return {
                adding: false,
            }
        },
        computed: Object.assign({}, mapGetters(['products']), {
            availableProducts () {
                let links = this.$store.state.products.product_bundles.filter(link => link.bundle_id === this.bundleId)
                let ids     = []
                for (let link in link) {
                    ids.push(links[link].product_id)
                }
                return this.products.filter(product => ids.indexOf(product.id) === -1).sort((a, b) => sortAlphaNum(a.sku, b.sku))
            },
            bundledProducts () {
                let links = this.$store.state.products.product_bundles.filter(link => link.bundle_id === this.bundleId)
                let ids     = []
                for (let link in links) {
                    ids.push(links[link].product_id)
                }
                return this.products.filter(product => ids.indexOf(product.id) !== -1).map(product => {
                    return Object.assign(product, {
                        link_id: links.find(b => b.product_id === product.id).id
                    })
                })
            }
        }),
        methods: {
            add(productId) {
                this.$store.dispatch(CREATE_PRODUCT_BUNDLE, {
                    product_id: productId,
                    bundle_id: this.bundleId
                })
                this.adding = false
            },
            remove(product) {
                this.$store.dispatch(DELETE_PRODUCT_BUNDLE, {
                    id: product.link_id,
                    product_id: this.productId,
                    bundle_id: this.bundleId,
                })
            }
        }
    };
</script>



// WEBPACK FOOTER //
// BundleProducts.vue?2826a3fa